export default function Profile() {
  return <div className="p-6">Update Profile Page</div>;
}